import React, { useContext, useState } from 'react';
import { AppsMenuHtml } from '../types/AppsMenuHtml';

type AppsMenuContextType = {
    appsMenu: AppsMenuHtml | null;
    setAppsMenu: (appsMenu: AppsMenuHtml | null) => void;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
};

export const AppsMenuContext = React.createContext<AppsMenuContextType>(undefined!);

interface AppsMenuContextProviderProps {
    children: React.ReactNode;
}

export const AppsMenuContextProvider = ({ children }: AppsMenuContextProviderProps) => {
    const [appsMenu, setAppsMenu] = useState<AppsMenuHtml | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <AppsMenuContext.Provider
            value={{
                appsMenu,
                setAppsMenu,
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </AppsMenuContext.Provider>
    );
};

export const useAppsMenuStore = () => useContext(AppsMenuContext);
